<template>
    <div :class="classObject" class="border-2 shrink-0 h-2.5 rounded-full w-2.5"></div>
</template>

<script>
export default {
    name: 'CardRarityIndicator',
    props: {
        rarity: {
            type: String,
            default: 'common',
            required: true,
        },
    },
    data() {
        return {
            classObject: {
                'bg-gray-800 border-2 border-gray-500': this.rarity === 'common',
                'bg-blue-300 border-2 border-gray-500': this.rarity === 'uncommon',
                'bg-yellow-300 border-2 border-gray-500': this.rarity === 'rare',
                'bg-orange-500 border-2 border-gray-500': this.rarity === 'mythic',
            },
        };
    },
};
</script>
